// import React, { useState } from "react";

// const ComingSoonScreen = () => {
//   const [email, setEmail] = useState("");
//   const [message, setMessage] = useState("");

//   const handleEmailChange = (e) => {
//     setEmail(e.target.value);
//   };

//   const handleNotifyMeClick = () => {
//     if (email.trim() === "") {
//       setMessage("Please enter a valid email address.");
//     } else {
//       setMessage("Thank you! We’ll notify you when we’re live.");
//       setEmail(""); // Clear the input
//     }
//   };

//   const animationKeyframes = `
//     @keyframes bounce {
//       0%, 100% {
//         transform: translateY(0);
//       }
//       50% {
//         transform: translateY(-10px);
//       }
//     }

//     @keyframes gradientShift {
//       0% {
//         background-position: 0% 50%;
//       }
//       50% {
//         background-position: 100% 50%;
//       }
//       100% {
//         background-position: 0% 50%;
//       }
//     }
//   `;

//   const containerStyle = {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     height: "100vh",
//     background: "linear-gradient(-45deg, #ff9a9e, #fad0c4, #fbc2eb, #a18cd1)",
//     backgroundSize: "400% 400%",
//     color: "#ffffff",
//     textAlign: "center",
//     fontFamily: "'Poppins', sans-serif",
//     animation: "gradientShift 15s ease infinite",
//   };

//   const logoStyle = {
//     marginBottom: "20px",
//   };

//   const titleStyle = {
//     fontSize: "3rem",
//     margin: "10px 0",
//     fontWeight: "bold",
//     textShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
//     letterSpacing: "2px",
//   };

//   const descriptionStyle = {
//     fontSize: "1.2rem",
//     margin: "0 0 20px",
//     lineHeight: "1.5",
//     textShadow: "1px 1px 3px rgba(0, 0, 0, 0.3)",
//     color: "#000000"
//   };

//   const inputContainerStyle = {
//     marginTop: "20px",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",

//   };

//   const inputStyle = {
//     padding: "10px",
//     fontSize: "1rem",
//     borderRadius: "10px",
//     border: "none",
//     outline: "none",
//     marginBottom: "10px",
//     width: "80%",
//     maxWidth: "300px",
//     boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
//   };

//   const buttonStyle = {
//     padding: "12px 25px",
//     marginTop: "15px",
//     fontSize: "1rem",
//     borderRadius: "10px",
//     border: "none",
//     background: "#ffffff",
//     color: "#ff758c",
//     fontWeight: "bold",
//     cursor: "pointer",
//     animation: "bounce 2s infinite",
//     transition: "background-color 0.3s ease, transform 0.2s",
//     boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.3)",
//   };

//   const buttonHoverStyle = {
//     backgroundColor: "#ff758c",
//     color: "#ffffff",
//     transform: "scale(1.05)",
//   };

//   const messageStyle = {
//     marginTop: "10px",
//     fontSize: "1rem",
//     fontStyle: "italic",
//     color: "#ffffff",
//     textShadow: "1px 1px 3px rgba(0, 0, 0, 0.5)",
//   };

//   return (
//     <div style={containerStyle}>
//       <style>
//         {animationKeyframes}
//       </style>
//       <img 
//         src="/images/logo.png" 
//         alt="Logo" 
//         style={logoStyle} 
//       />
//       <h1 style={titleStyle}>Coming Soon</h1>
//       <p style={descriptionStyle}>
//         We’re working hard to bring something amazing to you. Stay tuned!
//       </p>
//       <div style={inputContainerStyle}>
//         <input
//           type="email"
//           value={email}
//           onChange={handleEmailChange}
//           placeholder="Enter your email"
//           style={inputStyle}
//         />
//         <button
//           style={buttonStyle}
//           onMouseEnter={(e) => Object.assign(e.target.style, buttonHoverStyle)}
//           onMouseLeave={(e) => Object.assign(e.target.style, buttonStyle)}
//           onClick={handleNotifyMeClick}
//         >
//           Notify Me
//         </button>
//         {message && <p style={messageStyle}>{message}</p>}
//       </div>
//     </div>
//   );
// };

// export default ComingSoonScreen;












import React, { useRef } from "react";
import Header from "./../components/Header";
import ShopSection from "./../components/homeComponents/ShopSection";
// import PortraitsSection from "./../components/homeComponents/PortraitsSection";
import CalltoActionSection from "./../components/homeComponents/CalltoActionSection";
import ContactInfo from "./../components/homeComponents/ContactInfo";
import Footer from "./../components/Footer";

const HomeScreen = ({ match }) => {
  window.scrollTo(0, 0);
  const keyword = match.params.keyword;
  const pagenumber = match.params.pagenumber;

  const shopSectionRef = useRef(null);

  const handleScrollToShop = () => {
    if (shopSectionRef.current) {
      const section = shopSectionRef.current.querySelector('.section');
      if (section) {
        section.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  };

  const animationKeyframes = `
    @keyframes zoomIn {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.1);
      }
      100% {
        transform: scale(1);
      }
    }
  `;

  const containerStyle = {
    position: 'relative',
    height: '605px',
    overflow: 'hidden',
  };

  const backgroundStyle = {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundImage: 'url("/images/header_img.png")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    animation: 'zoomIn 10s ease-in-out infinite',
    zIndex: -1,
  };

  // const mobileTextStyle = {
  //   position: 'absolute',
  //   top: '50%',
  //   left: '50%',
  //   transform: 'translate(-50%, -50%)',
  //   fontSize: '12px',
  //   color: '#fff',
  //   textAlign: 'center',
  //   fontWeight: 'bold',
  //   display: 'none',
  // };

  return (
    <div>
      <style>
        {animationKeyframes}
        
        {`@media (max-width: 768px) {
          .mobile-center-text {
            display: block !important; /* Show text on small screens */
          }
        }`}
      </style>
      {!keyword && (
        <div style={containerStyle}>
          <div style={backgroundStyle}></div>
          <Header className="header" />
          <div className="button-container">
            <button 
              type="button" 
              className="shop-my-art-button"
              onClick={handleScrollToShop}
            >
              SHOP NOW
            </button>
          </div>
        </div>
      )}
      {keyword && <Header className="header" />}
      <ShopSection 
        keyword={keyword} 
        pagenumber={pagenumber} 
        ref={shopSectionRef}
      />
      <CalltoActionSection />
      <hr className="mt-4 border-gray-300" />
      <ContactInfo />
      <Footer />
    </div>
  );
};

export default HomeScreen;
